import { createSlice } from '@reduxjs/toolkit';

import { useRedux } from 'utils/redux';
import {
    fetchArticleDetail, fetchArticleList, fetchArticleHighlightList, searchArticle, fetchPreviewArticle
} from 'api/article';

const initialState = {
    articleList: [],
    articleHighLightList: [],
    articleDetail: {},
    nextArticle: {},
    prevArticle: {},
    loading: false,
    success: false,
    total: 0,
    currentPage: 0,
    lastPage: 0,
    keywordList: [],
    recommendation: []
};

export const articleSlice = createSlice({
    name: 'article',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchArticleList.pending, state => {
            state.loading = true;
            state.articleList = [];
            state.success = false;
            state.total = 0;
        });
        builder.addCase(fetchArticleList.fulfilled, (state, action) => {
            state.loading = false;
            state.articleList = action.payload.list;
            state.success = true;
            state.total = action.payload.total;
        });
        builder.addCase(fetchArticleList.rejected, state => {
            state.loading = false;
            state.articleList = [];
            state.total = 0;
            state.success = false;
        });
        builder.addCase(fetchArticleHighlightList.pending, state => {
            state.loading = true;
            state.articleHighLightList = [];
            state.success = false;
        });
        builder.addCase(fetchArticleHighlightList.fulfilled, (state, action) => {
            state.loading = false;
            state.articleHighLightList = action.payload.list;
            state.success = true;
        });
        builder.addCase(fetchArticleHighlightList.rejected, state => {
            state.loading = false;
            state.articleHighLightList = [];
            state.success = false;
        });
        builder.addCase(fetchArticleDetail.pending, state => {
            state.loading = true;
            state.articleDetail = {};
            state.nextArticle = {};
            state.prevArticle = {};
            state.recommendation = [];
        });
        builder.addCase(fetchArticleDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.articleDetail = action.payload.content;
            state.nextArticle = action.payload.nextArticle;
            state.prevArticle = action.payload.prevArticle;
            state.recommendation = action.payload.recommendation;
        });
        builder.addCase(fetchArticleDetail.rejected, state => {
            state.loading = false;
            state.articleDetail = {};
            state.nextArticle = {};
            state.prevArticle = {};
            window.location.replace('/');
            state.recommendation = [];
        });
        builder.addCase(fetchPreviewArticle.pending, state => {
            state.loading = true;
            state.articleDetail = {};
            state.nextArticle = {};
            state.prevArticle = {};
            state.recommendation = [];
        });
        builder.addCase(fetchPreviewArticle.fulfilled, (state, action) => {
            state.loading = false;
            state.articleDetail = action.payload.content;
            state.nextArticle = action.payload.nextArticle;
            state.prevArticle = action.payload.prevArticle;
            state.recommendation = action.payload.recommendation;
        });
        builder.addCase(fetchPreviewArticle.rejected, state => {
            state.loading = false;
            state.articleDetail = {};
            state.nextArticle = {};
            state.prevArticle = {};
            window.location.replace('/');
            state.recommendation = [];
        });
        builder.addCase(searchArticle.pending, state => {
            state.loading = true;
            state.articleList = [];
            state.success = false;
            state.total = 0;
            state.currentPage = 0;
            state.lastPage = 0;
            state.keywordList = [];
            state.recommendation = [];
        });
        builder.addCase(searchArticle.fulfilled, (state, action) => {
            state.loading = false;
            state.articleList = action.payload.list;
            state.success = true;
            state.total = action.payload.total;
            state.currentPage = action.payload.currentPage;
            state.lastPage = action.payload.lastPage;
            state.keywordList = action.payload.keywordList;
            state.recommendation = action.payload.recommendation;
        });
        builder.addCase(searchArticle.rejected, state => {
            state.loading = false;
            state.articleList = [];
            state.success = false;
            state.total = 0;
            state.currentPage = 0;
            state.lastPage = 0;
            state.keywordList = [];
            state.recommendation = [];
        });
    },
});

/* eslint-disable  @typescript-eslint/no-explicit-any */
const selectArticle = (state: any) => state.article;

export const useArticle = () => useRedux(selectArticle, {
    fetchArticleList, fetchArticleDetail, fetchArticleHighlightList, searchArticle, fetchPreviewArticle
});
